import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=bcd11c7e&scoped=true&"
import script from "./Feedback.vue?vue&type=script&lang=ts&"
export * from "./Feedback.vue?vue&type=script&lang=ts&"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=bcd11c7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd11c7e",
  null
  
)

export default component.exports